import DriverRegistration from './DriverRegistration';

export default DriverRegistration;
